<template>
  <svg 
    v-bind="$attrs"
    :width="width"
    :height="width"
    viewBox="0 0 18 18" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M9 17V9M9 9V1M9 9H17M9 9H1" 
      :stroke="stroke" 
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 18,
  },
  height: {
    type: [String, Number],
    default: 18,
  },
  stroke: {
    type: String,
    default: 'currentColor',
  },
});
</script>
